import React from "react"
import { FaMinus, FaPlus, FaTrashAlt } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { isDirectionLtr, onlyPositiveNumber } from "utils"
import classes from "./KfsPill.module.scss"

const KfsPill = props => {
  const {
    value,
    max,
    min = 0,
    onChange,
    onDelete
  } = props

  const i18n = useTranslation()[1]

  const handlePlus = () => {
    const newValue = value + 1

    if (newValue > max) return

    onChange(newValue)
  }

  const handleMinus = () => {
    const newValue =
      onlyPositiveNumber(value - 1)

    if (newValue < min) return

    newValue >= 0 && onChange(newValue)
  }

  return (
    <div className={classes["container"]}>
      {value <= 1 && !!onDelete
        ?
        <button
          className={clsx(classes["minus"],
            isDirectionLtr(i18n.language) && classes["minus-ltr"]
          )}
          onClick={onDelete}
        >
          <FaTrashAlt size={23} />
        </button>
        :
        <button
          className={clsx(classes["minus"],
            isDirectionLtr(i18n.language) && classes["minus-ltr"]
          )}
          onClick={handleMinus}
        >
          <FaMinus size={23} />
        </button>
      }

      <div className={classes["input"]}>
        {value}
      </div>

      <button
        onClick={handlePlus}
        className={clsx(classes["plus"],
          isDirectionLtr(i18n.language) && classes["plus-ltr"]
        )}
      >
        <FaPlus size={28} />
      </button>
    </div>
  )
}

export default KfsPill